import { API_URL } from './Constants';
import ApiService from './ApiService';
import { EditorState } from 'draft-js';
import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';

class AudioTheoBoPageApi {

    static getChiTietAudioTheoBoAdmin = async (postId, postType) => {
        try {
            let params = { postId, postType };

            console.log(params)

            return await ApiService.getDataWithParams(API_URL + "/audio-theo-bo/detail", params);
        } catch (error) {
        }
    };

    static submitPost = async (formData) => {
        const data = new FormData();
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("content", draftToHtml(convertToRaw(formData.content.getCurrentContent())));
        data.append("seoUrl", formData.seoUrl);
        data.append("nguoigiang", formData.nguoigiang);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.linkMp3) {
            data.append("ftpFilePath", formData.linkMp3);
        } else if (formData.ftpFilePath) {
            data.append("ftpFilePath", formData.ftpFilePath);
        }
        try {
            const response = await ApiService.postFormData(API_URL + "/audio-theo-bo/create", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    static updatePost = async (formData) => {
        const data = new FormData();
        data.append("postId", formData.postId);
        data.append("title", formData.title);
        data.append("description", formData.description);
        data.append("content", draftToHtml(convertToRaw(formData.content.getCurrentContent())));
        data.append("seoUrl", formData.seoUrl);
        data.append("nguoigiang", formData.nguoigiang);
        if (formData.categories && Array.isArray(formData.categories)) {
            formData.categories.forEach(catId => {
                data.append("categories", catId);
            });
        }
        data.append("active", formData.active);
        data.append("isNew", formData.isNew);
        data.append("isHot", formData.isHot);
        data.append("isHome", formData.isHome);
        data.append("isSlide", formData.isSlide);
        data.append("isDeleteFile", formData.isDeleteFile);

        if (formData.image) {
            data.append("image", formData.image);
        }
        if (formData.ftpImagePath) {
            data.append("ftpImagePath", formData.ftpImagePath);
        }
        if (formData.linkMp3) {
            data.append("ftpFilePath", formData.linkMp3);
        } else if (formData.ftpFilePath) {
            data.append("ftpFilePath", formData.ftpFilePath);
        }

        try {
            const response = await ApiService.postFormData(API_URL + "/audio-theo-bo/update", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
}

export default AudioTheoBoPageApi;